// extracted by mini-css-extract-plugin
export default {"statusTag":"statusTag__6klvT","online":"online__tmPCf","liveTalk":"liveTalk__lWkt4","offline":"offline__6Bi0+"};